import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'
import VueJwtDecode from 'vue-jwt-decode'
import utf8 from 'utf8'

const state = {
  user: {},
  token: '',
  showPopCPM: true
}

const mutations = {
  SET_USER_AUTH (state, payload) {   
    localStorage.setItem('token', payload)
    let decodedToken = VueJwtDecode.decode(payload)
    let user = {
      id: decodedToken.id,
      email: decodedToken.email,
      name: utf8.decode(decodedToken.name),
      username: decodedToken.username,
      profile: decodedToken.profile,
      team: decodedToken.team,
      leader: decodedToken.leader,
      role: decodedToken.role,
      segment: decodedToken.segment,
      travel: decodedToken.travel,
      product: decodedToken.product,
      isAdminOfUsers: decodedToken.isAdminOfUsers
    }
    Object.assign(state.user, user);
    state.showPopCPM = true;
  },
  LOG_OUT (state) {
    localStorage.removeItem('token')
    state = {
      user: {},
      token: '',
      showPopCPM: true
    }
  },
  SET_SHOW_CPM (state, payload) {
    state.showPopCPM = false;
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  }
}

const actions = {
  login: (context, user) => {
    return Vue.http.post(`${env.API}/api/user/signin`, user)
      .then((response) => {
        context.commit('SET_USER_AUTH', response.body.message)
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  changePwd: (context, user) => {
    return Vue.http.post(`${env.API}/api/user/change-password`, user)
      .then((response) => {
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  logOut: (context) => context.commit('LOG_OUT'),
  setShowCPM: (context) => context.commit('SET_SHOW_CPM')
}

const getters = {
  getUserInfo: (state) => state.user,
  getToken: (state) => state.token,
  getStatePerProfile: (state) => {
    if (state.user.profile.name == 'autoevaluador') {
      return [1,2]
    } else if (state.user.profile.name == 'consultor') {
      return [1,2,3]
    } else if (state.user.profile.name == 'supervisor') {
      return [1,2]
    } else if (state.user.profile.name == 'admin') {
      return [1,2,3]
    } else if (state.user.profile.name == 'observador') {
      return [1,2]
    }
  },
  canAccessTab: (state) => (tab) => {
    if (state.user.profile.hasOwnProperty('auth')) {    
      if (state.user.profile.auth.hasOwnProperty('tabs')) {
        if (state.user.profile.auth.tabs.indexOf(tab) != -1) {          
          return true
        } else {          
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  },
  getPopCPM: (state) => state.showPopCPM
}

export const auth = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js